import { GANGSTABET_STORY } from "src/constants/images";
const StoryCard = ({ image, title, desc, level, link }) => {
  return (
    <div className="story--card" onClick={() => {
      window.open(link, '_blank')
    }}>
          <img className="story--img" src={image} alt="bank" />
          <div className="story--heading-wrapper">
              <div className="story--heading">{title}</div>
              <div className="level--wrapper">
                  <img src={GANGSTABET_STORY.STORY_ICON} alt="level-icon" />
                  <div className="level--text">{level}</div> 
              </div>
          </div>
          <div className="story--desc">{ desc }</div>
    </div>
  );
};

export default StoryCard;
